// const images = require.context(`/public/assets/images`, true);

// export const dynamicImage = (image: string | undefined) => {
//     return images(`./${image}`);
// };



export const dynamicImage = (image: string | undefined) => {
  if (!image) return '';
  return `assets/images/${image}`; // no leading slash
};